(ns ycweb.app.website.unsubscribe.unsubscribe
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.app.website.website :as website]))

(def three-or-more-uuid #uuid"f53fddbe-8eda-4776-99ac-62096742b7c1")

(rum/defc unsubscribe < rum/reactive [app-atom]
  (let [user-atom (rum/cursor-in app-atom [:newsletter-interests :user])
        user (rum/react user-atom)
        user-newsletter-selected-atom (rum/cursor-in user-atom [:user/newsletter :interest/selected?])
        special-interests-atom (rum/cursor-in app-atom [:newsletter-interests :special-interests])
        special-interests (rum/react special-interests-atom)
        newsletters-atom (rum/cursor-in app-atom [:newsletter-interests :newsletters])
        three-or-more-atom (rum/cursor-in newsletters-atom [three-or-more-uuid :interest/selected?])
        selected-set (set (conj (map #(:interest/selected? %) (vals special-interests)) @user-newsletter-selected-atom))]
    [:div
     {:class (u/bem :yc-page-content [:standard])}
     [:div
      {:class (u/bem :yc-section [:large])}
      [:div.form.u-max-width-480
       (headings/heading "Email preferences"
         {:type :h1
          :size :large})
       [:p.yc-paragraph (str "Email: " (:user/email user))]
       [:div.u-margin-top-30
        {:class (u/bem :form-section [:lined])}
        [:label.form-field.toggle-label
         {:for (str "special-interests-surveys-footer" "newsletter") :key "newsletter"}
         [:input.toggle
          (merge
            (forms/checkbox-props
              three-or-more-atom
              #(grid/dispatch-action app-atom :web.unsubscribe/newsletter-choose-interest {:special-interests-labels ["Personalised offers"]})
              nil
              false
              false)
            {:id (str "special-interests-surveys-footer" "newsletter")})]
         [:span.toggle__graphic-wrapper
          [:span.toggle__graphic]]
         [:span.toggle__text
          [:span.toggle__title "Newsletters and personalised offers"]
          [:span "Find out first about new launches and deals, plus the chance to receive occasional vouchers"]]]
        (map
          (fn [[uuid interest]]
            [:label.form-field.toggle-label
             {:for (str "special-interests-surveys-footer" uuid) :key uuid}
             [:input.toggle
              (merge
                (forms/checkbox-props
                  (rum/cursor-in special-interests-atom
                    [uuid :interest/selected?])
                  #(grid/dispatch-action app-atom :web.unsubscribe/newsletter-interests  {})
                  nil
                  (rum/react three-or-more-atom)
                  false)
                {:id (str "special-interests-surveys-footer" uuid)})]
             [:span.toggle__graphic-wrapper
              [:span.toggle__graphic]]
             [:span.toggle__text
              [:span.toggle__title
               (when (= (:ent/display-name interest) "Personalised offers")
                 "Personalised offers only")]
              (when (= (:ent/display-name interest) "Personalised offers")
                [:span "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"])]])
          special-interests)]

       [:div.form-field
        (rum/with-key
          (forms/toggle "Order-related emails" (rum/cursor app-atom :newsletter/orders)
            {:id "toggle-transactional"
             :name "type[]"
             :default-checked true
             :disabled true})
          "newsletter/orders")]
       [:hr {:class (u/bem :u-hr [:or :default])}]
       [:div.u-max-width-480
        {:class (u/bem :flex-grid-group [:flush-force :align-left])}
        [:div
         {:class (u/bem :flex-grid-block [:s-fluid])}
         [:div.flex-grid-content
          (rum/with-key
            (buttons/button-web "Subscribe to all"
              {:style :secondary-noborder
               :size :default
               :full true
               :flat-style :flat-to-raised
               :icon :thumbs-up
               :class "button--text-link"
               :disabled
               (cond
                 (and (= (count selected-set) 1) (= (first selected-set) true))
                 true

                 :else
                 false)
               :on-click #(grid/dispatch-action app-atom :web.unsubscribe/all-newsletter-interests {:all-interests true})})
            "subscribe-all")]]
        [:div
         {:class (u/bem :flex-grid-block [:s-fluid])}
         [:div.flex-grid-content
          (rum/with-key
            (buttons/button-web "Unsubscribe from all"
              {:style :secondary-noborder
               :size :default
               :full true
               :flat-style :flat-to-raised
               :icon :thumbs-down
               :class "button--text-link"
               :disabled
               (cond
                 (and (= (count selected-set) 1) (= (first selected-set) false))
                 true

                 :else
                 false)
               :on-click #(grid/dispatch-action app-atom :web.unsubscribe/all-newsletter-interests {:all-interests false})})
            "unsubscribe-all")]]]]]
     (toaster/loading-overlay app-atom :web/unsubscribe)]))

(defmethod flow/render-screen :web.unsubscribe [app-atom _]
  (website/screen-wrapper app-atom
    (unsubscribe app-atom)
    {}))

(defmethod grid/action :web.unsubscribe/newsletter-choose-interest [app-atom config _]
  (let [special-interests-atom (rum/cursor-in app-atom [:newsletter-interests :special-interests])
        user-atom (rum/cursor-in app-atom [:newsletter-interests :user])
        user-newsletter-label-uuid-atom (rum/cursor-in user-atom [:user/newsletter :ent/uuid])
        newsletters-atom (rum/cursor-in app-atom [:newsletter-interests :newsletters])
        newsletter-interest
        (->>
          @newsletters-atom
          (vals)
          (filter :interest/selected?)
          (map :ent/uuid)
          (remove nil?)
          (first))
        special-interests-labels (set (:special-interests-labels config))
        interests-to-select (filter #(contains? special-interests-labels (:ent/display-name %)) (vals @special-interests-atom))
        final-interests (map #(assoc % :interest/selected? true) interests-to-select)]
    (reset! user-newsletter-label-uuid-atom newsletter-interest)
    (when (not (nil? newsletter-interest))
      (doseq [interest final-interests]
        (swap! special-interests-atom assoc (:ent/uuid interest) interest)))
    (grid/dispatch-action app-atom :web.unsubscribe/newsletter-interests {})))

(defmethod t/transition-open :web.unsubscribe [app-atom _ params]
  (let [newsletter-interests (cmn/curact app-atom :newsletter-interests)]
    (cond
      (nil? newsletter-interests)
      (swap! app-atom update :newsletter-interests assoc :params params)

      :else
      (swap! app-atom update :newsletter-interests
        (fn [newsletter-interest]
          (->
            (reduce dissoc newsletter-interest [:user :mail-record :campaign])
            (assoc :params params)))))

    (toaster/open-overlay app-atom :web/unsubscribe)

    (comms/ajax-get :web/unsubscribed
      {:user {:ent/uuid (:uid params)}
       :mail-record {:ent/uuid (:mid params)}
       :campaign {:ent/uuid (:cid params)}})))

(defmethod comms/receive :web/unsubscribed [app-atom e]
  (toaster/close-overlay app-atom :web/unsubscribe)
  (swap! app-atom update :newsletter-interests
    (fn [newsletter-interests]
      (->
        newsletter-interests
        (assoc
          :newsletters (:newsletters e)
          :special-interests (:special-interests e)
          :user (:user e))
        (assoc-in [:params :cid] (get-in e [:campaign :ent/uuid]))))))

(defmethod grid/action :web.unsubscribe/newsletter-interests [app-atom config _]
  (toaster/open-toast app-atom :processing (cond (u/presence (:message config)) (:message config) :else "Saving") {:closetime 10000})
  (let [newsletter-interests (get @app-atom :newsletter-interests)
        user (:user newsletter-interests)
        user-newsletter-uuid (get-in user [:user/newsletter :ent/uuid])

        user-special-interests
        (->>
          (:special-interests newsletter-interests)
          (vals)
          (filter :interest/selected?)
          (map :ent/uuid)
          (remove nil?))]

    (comms/ajax-post :web.unsubscribed/save-newsletter-interest
      {:user
       {:ent/uuid (:ent/uuid user)
        :user/interests (conj user-special-interests user-newsletter-uuid)}
       :campaign
       {:ent/uuid (:cid (:params newsletter-interests))}})))

(defmethod grid/action :web.unsubscribe/all-newsletter-interests [app-atom config _]
  (let [user-atom (rum/cursor-in app-atom [:newsletter-interests :user])
        user-newsletter-label-uuid-atom (rum/cursor-in user-atom [:user/newsletter :ent/uuid])
        user-newsletter-selected-atom (rum/cursor-in user-atom [:user/newsletter :interest/selected?])
        newsletters-atom (rum/cursor-in app-atom [:newsletter-interests :newsletters])
        three-or-more-atom (rum/cursor-in newsletters-atom [three-or-more-uuid :interest/selected?])]

    (swap! app-atom update-in [:newsletter-interests :special-interests]
      (fn [interests]
        (reduce
          (fn [acc [uuid _]]
            (assoc-in acc [uuid :interest/selected?] (:all-interests config)))
          interests interests)))

    (if (:all-interests config)
      (do
        (reset! three-or-more-atom true)
        (reset! user-newsletter-label-uuid-atom three-or-more-uuid))
      (do
        (reset! three-or-more-atom false)
        (reset! user-newsletter-label-uuid-atom nil)))

    (reset! user-newsletter-selected-atom (:all-interests config))

    (grid/dispatch-action app-atom :web.unsubscribe/newsletter-interests
      {:message (cond (u/presence (:message config)) (:message config) :else "Saving")})))

(defmethod comms/receive :web.unsubscribed/save-newsletter-interest [app-atom e]
  (toaster/close-toast app-atom)
  (toaster/open-toast app-atom :success "Saved" {:closetime 2000}))

(defmethod grid/action :web.unsubscribe/reset-frequencies [app-atom config _]
  (let [user-atom (rum/cursor-in app-atom [:newsletter-interests :user])
        user-newsletter-uuid (cmn/curact user-atom [:user/newsletter :ent/uuid])
        selected-frequency-uuid-atom (rum/cursor-in user-atom [:frequency/selected :ent/uuid])]
    (reset! selected-frequency-uuid-atom user-newsletter-uuid)))